export default __webpack_public_path__ + "static/media/KB.d32524e0.png";